import { ListFilter } from "lucide-react"
import { type ReactNode, useRef, useState } from 'react';
import { Button } from "@/components/ui/button"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { useDialogContainer } from "./dialog-container-context"

interface DataTableFilterBaseProps {
  children: ReactNode;
  filterCount?: number;
  align?: "start" | "center" | "end";
  className?: string;
}

export function DataTableFilterBase({
  children,
  filterCount = 0,
  align = "start",
  className = "w-auto p-0"
}: DataTableFilterBaseProps) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const dialogContainer = useDialogContainer();

  return (
    <Popover
      open={open}
      onOpenChange={(isOpen) => {
        if (isOpen) setOpen(true);
      }}
      modal={true}
    >
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="relative w-6 h-8">
          <ListFilter className="h-4 w-4" />
          {filterCount > 0 && (
            <span className="text-sm absolute -right-1 top-0 text-black/50">
              {filterCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        ref={contentRef}
        className={className}
        align={align}
        container={dialogContainer}
        onOpenAutoFocus={(e) => {
          // Prevent default focus behavior and manually focus the input
          e.preventDefault();
          setTimeout(() => {
            const input = contentRef.current?.querySelector('input');
            if (input) {
              input.focus();
            }
          }, 0);
        }}
        onCloseAutoFocus={(e) => e.preventDefault()}
        onEscapeKeyDown={() => setOpen(false)}
        onPointerDownOutside={() => setOpen(false)}
        onInteractOutside={(e) => e.preventDefault()}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
